import { memo, useCallback } from 'react';
import { Button } from '@gravity-ui/uikit';

import { useNavigateReplace } from 'hooks';
import { routes } from 'routes';

import { ReactComponent as ErrorImg } from 'assets/images/404-img.svg';
import { ReactComponent as LogoImg } from 'assets/images/logo.svg';

const ErrorPage = () => {
	const navigate = useNavigateReplace();

	const handleClick = useCallback(
		(e: any) => {
			e.preventDefault();
			navigate(routes.root.getPath());
		},
		[navigate],
	);

	return (
		<div>
			<LogoImg />
			<ErrorImg />
			<div>
				<span>Что-то пошло не так</span>
				<span>Страница, которую вы запрашиваете, не существует</span>
				<Button onClick={handleClick}>Вернуться на главную</Button>
			</div>
		</div>
	);
};

export default memo(ErrorPage);
